import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export const getFavorites = async (userId: string): Promise<string[]> => {
  try {
    if (!userId) {
      console.warn('No user ID provided for getFavorites');
      return [];
    }

    const docRef = doc(db, 'users', userId, 'preferences', 'favorites');
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return docSnap.data().voiceIds || [];
    }
    
    // Initialize empty favorites if document doesn't exist
    await setDoc(docRef, { voiceIds: [] });
    return [];
  } catch (error) {
    console.error('Error fetching favorites:', error);
    return [];
  }
};

export const saveFavorites = async (userId: string, favorites: string[]): Promise<void> => {
  try {
    if (!userId) {
      throw new Error('No user ID provided for saveFavorites');
    }

    const docRef = doc(db, 'users', userId, 'preferences', 'favorites');
    await setDoc(docRef, { voiceIds: favorites });
  } catch (error) {
    console.error('Error saving favorites:', error);
    throw error;
  }
};